import React from "react";

import { Var } from "features/common/localisation";

type Props = {
  value: number | null | undefined;
};

export default function Percentage({ value }: Props) {
  return (
    <Var>
      {value === null || value === undefined
        ? "-"
        : `${(value * 100).toFixed(0)}%`}
    </Var>
  );
}
